import { OryLoginStatus, OryLoginType } from '../../ory/types';

export interface IAuthStore {
  accessToken?: string;
  error?: any;
  isFetching: boolean;
  isFirstLogin: boolean;
  preferUserLogin: boolean;
  redirectToResendWithEmail: string;
  resendInvitation: {
    error?: any;
    isFetching: boolean;
  };
  throttlingRetryAfter?: Date;
  oryLoginStatus?: OryLoginStatus;
  oryLoginType?: OryLoginType;
}

export function initialAuthStore(): IAuthStore {
  return {
    isFetching: false,
    isFirstLogin: false,
    oryLoginStatus: undefined,
    preferUserLogin: false,
    redirectToResendWithEmail: '',
    resendInvitation: {
      isFetching: false,
    },
    throttlingRetryAfter: undefined,
  };
}
